export default ({ request }) => ({
  // 供应商拜访评分记录相关接口
  scmInfoVisitScoreApi(data) {
    return request({
      url: '/digitalCenter/scmInfoVisitScore/getVisitScore',
      method: 'post',
      data,
    })
  },
  // 根据拜访编码查询评分记录接口
  getVisitScoreListApi(data) {
    return request({
      url: '/digitalCenter/scmInfoVisitScore/getVisitScoreList',
      method: 'post',
      data,
    })
  },
  // 评分记录详情接口
  getVisitScoreDetailApi(data) {
    return request({
      url: '/digitalCenter/scmInfoVisitScore/getVisitScoreDetail',
      method: 'post',
      data,
    })
  },
  // 新增拜访评分记录接口
  addVisitScoreApi(data) {
    return request({
      url: '/digitalCenter/scmInfoVisitScore/add',
      method: 'post',
      data,
    })
  },
  // 保存拜访评分记录接口
  saveVisitScoreApi(data) {
    return request({
      url: '/digitalCenter/scmInfoVisitScore/save',
      method: 'post',
      data,
    })
  },
  directSaveVisitScoreApi(data) {
    return request({
      url: '/digitalCenter/scmInfoVisitScore/directSave',
      method: 'post',
      data,
    })
  },
  // 删除拜访评分记录接口
  delVisitScoreApi(data) {
    return request({
      url: '/digitalCenter/scmInfoVisitScore/del',
      method: 'post',
      data,
    })
  },
  // 根据供应商编码查询评分记录接口
  visitScoreListApi(data) {
    return request({
      url: '/digitalCenter/scmInfoVisitScore/list',
      method: 'post',
      data,
    })
  },
})
